import { Target, Transition } from "framer-motion"
import { useRef } from "react"

type Props = {
  enter?: string | Target
  exit?: string | Target
  center?: string | Target
  opacity?: boolean
}

export default function useAnimationDirectionVariants(
  direction: "forward" | "back",
  props: Props = {}
) {
  const dirRef = useRef<"forward" | "back">(direction)
  dirRef.current = direction

  const { opacity } = props
  const enter = props.enter
    ? typeof props.enter === "string"
      ? { x: props.enter }
      : props.enter
    : { x: "100%" }
  const exit = props.exit
    ? typeof props.exit === "string"
      ? { x: props.exit }
      : props.exit
    : { x: "-100%" }
  const center = props.center
    ? typeof props.center === "string"
      ? { x: props.center }
      : props.center
    : { x: 0 }

  return {
    enter: () => ({
      ...(dirRef.current === "back" ? exit : enter),
      opacity: opacity ? 0 : undefined,
    }),
    center: { ...center, opacity: opacity ? 1 : undefined },
    exit: () => ({
      ...(dirRef.current === "back" ? enter : exit),
      opacity: opacity ? 0 : undefined,
    }),
  }
}
